<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
/* 全局样式重置和现代化设计 */
* {
  box-sizing: border-box;
}

html,
body,
#app {
  padding: 0px;
  margin: 0px;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #303133;
  background-color: #f5f7fa;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
  transition: background 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 全局动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 卡片通用样式增强 */
.el-card {
  border-radius: 12px !important;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.el-card:hover {
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

/* 按钮样式增强 */
.el-button {
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.el-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.el-button:active {
  transform: translateY(0);
}

/* 输入框样式增强 */
.el-input__inner,
.el-textarea__inner {
  border-radius: 6px;
  transition: all 0.3s ease;
}

.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* 表格样式增强 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
}

.el-table th {
  background-color: #fafafa;
  font-weight: 600;
  color: #303133;
}

.el-table--border {
  border: 1px solid #ebeef5;
}

.el-table--border::after {
  background-color: #ebeef5;
}

/* 标签样式 */
.el-tag {
  border-radius: 4px;
  font-weight: 500;
}

/* 菜单样式增强 */
.el-menu {
  border-radius: 0;
}

.el-menu-item {
  border-radius: 6px;
  margin: 4px 8px;
  transition: all 0.3s ease;
}

.el-menu-item:hover {
  background-color: rgba(64, 158, 255, 0.1);
}

.el-menu-item.is-active {
  background-color: rgba(64, 158, 255, 0.15);
  color: #409eff;
  font-weight: 600;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .el-card {
    border-radius: 8px;
  }

  /* 移动端按钮尺寸和阴影减弱，避免遮挡内容 */
  .el-button {
    padding: 6px 10px;
    box-shadow: none !important;
    transform: none !important;
  }

  .el-button:hover {
    box-shadow: none !important;
    transform: none !important;
  }
}
</style>
